import { FormLabel } from "@mui/material";
import { IFormLabel } from "../../../services/custom-forms-data-service/TemplateModels";


export type CustomFormLabelProps = {
    key?: React.Key | null | undefined,
    label: IFormLabel
};


export default function CustomFormLabel({
  key,
  label
}: CustomFormLabelProps) {

     return (
      <FormLabel key={key} component='div'>{label.text}</FormLabel>
    );
}
